var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header'),_c('Intro',{on:{"sectionClick":_vm.onSectionClick}}),(_vm.active)?_c('div',[_c('What'),_c('Works'),_c('Wavicle'),_c('Banner'),_c('SectionText'),_c('Earning'),_c('Benefit')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }